// The room outline surfaces are built on. Defined once, in floorplan-core,
// where room-flow and av-compat read it too: a wall index that meant one
// thing here and another there would put a screen on the wrong wall.
export { roomFloorPolygon as getRoomPolygon } from '@roomtreatment/floorplan-core';
